import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cover from "assets/images/studs/M8.jpg";
import cover1 from "assets/images/studs/imc20.jpg";
import cover2 from "assets/images/studs/imc15.jpg";
import cover3 from "assets/images/studs/imc26.jpg";
import cover4 from "assets/images/bg-contactus.jpg";

const images = [
    {
        url: cover,
        caption: "Learn, Compete, and Succeed with IM Chess.",
        desc: "Powered by IM Manush Shah"
    },
    {
        url: cover1,
        caption: "A Chess Centre with 360° Experience for chess journey.",
        desc: "The Epitome of chess"
    },
    {
        url: cover2,
        caption: "Take guidance from expert coaches",
        desc: "Learn From International Master"
    },
    {
        url: cover3,
        caption: "A place where you can direct connect with Titled players."
    },
    {
        url: cover4,
        caption: "Get many wins & learn to handle failure curves positively with expert coaches"
    },
    {
        url: cover4,
        caption: "Practice play.",
        desc: "Everything is Win, when the goal is to Experience the game of chess"
    }
];

export default function CoverSlider() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false
    };

    return (
        <Box sx={{ width: "100%", position: "relative" }}>
            <Slider {...settings}>
                {images.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: "relative",
                            height: { xs: "50vh", md: "90vh" },
                            backgroundImage: `url(${item.url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center"
                        }}
                    >
                        {/* Transparent overlay */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)" // black overlay with 50% opacity
                            }}
                        />

                        {/* Caption on top of overlay */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                                px: 2
                            }}
                        >
                            <Typography
                                variant="h4"
                                color="orange"
                                sx={{ fontWeight: "bold", textShadow: "2px 2px 8px rgba(0,0,0,0.7)" }}
                            >
                                {item.caption}
                            </Typography>
                            {item.desc && <Typography
                                variant="h3"
                                color="orange"
                                sx={{ fontWeight: "bold", textShadow: "2px 2px 8px rgba(0,0,0,0.7)" }}
                            >
                                {item.desc}
                            </Typography>
                            }
                        </Box>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
}
